import { useCallback, useEffect, useState } from "react";
import { MAX_RETRIES } from "../../configs/configs";
import useFetch from "../../hooks/useFetch";
import { useShowMessage } from "../Common/showMessage";
import useRetry from "../Common/useRetry";

function useGetMerchantId(receiptPrice) {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [merchantId, setMerchantId] = useState();
  const { retryCount, setRetryCount } = useRetry(
    () => getMerchantId(),
    MAX_RETRIES
  );

  const getMerchantId = useCallback(() => {
    fetchWrapper({
      endpoint_url: "merchant/getMerchantId",
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          let data = fetch_output["data"];
          setMerchantId(data);
          setRetryCount(0);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({ apiType: "fetch", message: "Get Merchant ID" });

        setRetryCount((prev) => prev + 1);
      },
      onResponseError: () => {
        if (retryCount === MAX_RETRIES)
          showMessage({ apiType: "response", message: "Get Merchant ID" });

        setRetryCount((prev) => prev + 1);
      },
    });
  }, [fetchWrapper]);

  useEffect(() => {
    if (receiptPrice.cash != null) getMerchantId();
  }, [receiptPrice?.cash]);

  return { merchantId };
}

export default useGetMerchantId;
